import { TooltipProps } from '@mui/material/Tooltip';
export const tooltipProps: Partial<TooltipProps> = {
  placement: 'top',
  arrow: true,
  componentsProps: {
    tooltip: {
      sx: {
        width: '240px',
        height: '80px',
        background: 'var(--black-200)',
        opacity: 1,
        transform: 'rotate(0deg)',
        mt: '10px',
        boxShadow: '4px 4px 4px 0px #00000040',
        borderRadius: '8px',
      },
    },
    arrow: {
      sx: {
        color: 'var(--black-200)',
        fontSize: '2rem',
      },
    },
  },
};

export const TooltipContent = ({ text }: { text: string }) => (
  <span
    style={{
      fontFamily: 'Open Sans',
      fontWeight: 400,
      fontStyle: 'normal',
      fontSize: '14px',
      lineHeight: '20px',
      letterSpacing: '0',
      verticalAlign: 'middle',
      color: 'black',
      padding: '8px 12px',
      borderRadius: '4px',
      display: 'inline-block',
    }}
  >
    {text}
  </span>
);
